import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';

import { MyService } from '../my.service';
import { User } from '../models/user-info.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

// @ts-ignore
// import * as bootstrap from 'bootstrap'; // ← اضافه کن
declare var bootstrap: any;

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.css']
})
export class UserInfoComponent implements OnInit {

 baseUrl = environment.apiBaseUrl;
  @ViewChild('userModal') userModal: ElementRef | undefined;


  userList: any[] = [];
  userObj: any ={
      "id":0,
      "userName":"",
      "email":"",
      "phoneNumber":"",
      "role":""
  }
  http = inject(HttpClient);

   ngOnInit(): void {
  this.getAllUser()
  }


  // constructor(private userService: Service) {}

  openModal(): void {
  // console.log("openModal triggered");
  if (this.userModal) {
    const modal = new bootstrap.Modal(this.userModal.nativeElement);
    modal.show();
  } else {
    console.warn("userModal is undefined!");
  }
}


closeModal(): void {
  if (this.userModal) {
    const modal = bootstrap.Modal.getInstance(this.userModal.nativeElement);
    if (modal) modal.hide();
  }
}

  getAllUser(): void {
    this.http.get<User[]>(`${this.baseUrl}/users`).subscribe((res) => {
      this.userList = res;
      // console.log(this.userList); // چاپ داده‌ها برای بررسی
    });
  }

 onSave(): void {
  if (this.userObj.id === 0) {
    // افزودن
    const newUser = { ...this.userObj };
    delete newUser.id;
    this.http.post<User>(`${this.baseUrl}/users`, newUser).subscribe((res) => {
      this.getAllUser();
      this.closeModal();
    });
  } else {
    // ویرایش ← ارسال با post
    this.http.post<User>(`${this.baseUrl}/users/update`, this.userObj).subscribe((res) => {
      this.getAllUser();
      this.closeModal();
    });
  }
}
//   onSave(): void {
//   if (this.userObj.id === 0) {
//     // افزودن
//     const newUser = { ...this.userObj };
//     delete newUser.id; // ← ID را حذف کن که نره به سرور
//     this.http.post<User>(`${this.baseUrl}/users`, newUser).subscribe((res) => {
//       this.getAllUser();
//       this.closeModal();
//     });
//   } else {
//     // ویرایش
//     this.http.put<User>(`${this.baseUrl}/users/${this.userObj.id}`, this.userObj).subscribe((res) => {
//       this.getAllUser();
//       this.closeModal();
//     });
//   }
// }


  // باز کردن مدال برای ویرایش
  openEditModal(user: any): void {
    this.userObj = { ...user }; // پر کردن فیلدها با داده‌های کاربر انتخاب‌شده
    this.openModal();
  }

  // حذف کاربر
  // delete(userId: number): void {
  //   if (confirm("آیا مطمئن هستید که می‌خواهید این کاربر را حذف کنید؟")) {
  //     this.http.delete(`${this.baseUrl}/users/${userId}`).subscribe(() => {
  //       this.getAllUser(); // بعد از حذف، لیست کاربران را مجدد بگیر
  //     });
  //   }
  // }
  delete(userId: number): void {
  if (confirm("آیا مطمئن هستید که می‌خواهید این کاربر را حذف کنید؟")) {
    this.http.post(`${this.baseUrl}/users/delete`, userId).subscribe(() => {
      this.getAllUser();
    });
  }
}

}

